// | ------------------------------------------------------------------------
// | GSAP Scroll Animations
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollSmoother } from "gsap/all";


import { homepageAnimations } from "./homepage";
import { sectorsScrollSpy } from "./animations/sectorsScrollSpy";
import { heroEntry } from "./animations/heroEntry";
import { timeline } from "./animations/timeline";
import { benefitItems } from "./animations/benefitItems";
import { infoItems } from "./animations/infoItems";
import { serviceItems } from "./animations/serviceItems";
import { abstractBg } from "./animations/abstractBg";
import { virtualOfficeCta } from "./animations/virtualOfficeCta";
import { stickySocial } from "./animations/stickySocial";
import { projectImgGallery } from "./animations/projectImgGallery";


// | ------------------------------------------------------------------------

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

//console.log(gsap.plugins);

// | ------------------------------------------------------------------------

// Global settings
ScrollTrigger.normalizeScroll(true);
const showMarkers = false; // Set to true to enable markers

// | ------------------------------------------------------------------------

// Set up smooth scroll

let smoother = ScrollSmoother.create({
  wrapper: '#smooth-wrapper',
  content: '#smooth-content',
  smooth: 3,
  //wholePixels: true,
})

export {smoother}

// Create function to allow in page scrolling links

function scrollToHash(hash, e) {
    const elem = hash ? document.querySelector(hash) : false;
    if (elem) {
        e.preventDefault(); // Prevents the default browser scrolling
        smoother.scrollTo(elem, true); // Scrolls to the element
    }
}

// add event listener for in page links

document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
        scrollToHash(a.getAttribute('href'), e);
    });
});
  

// | ------------------------------------------------------------------------

const scrollAnimationSections = document.querySelectorAll(".scroll-animation");

scrollAnimationSections.forEach((scrollAnimation) => {

  if (scrollAnimation.classList.contains("homepage-trigger")) {
    homepageAnimations(showMarkers, scrollAnimation);
  } 

  if (scrollAnimation.classList.contains("sectors-scrollspy-section")) {
    sectorsScrollSpy(showMarkers);
  }

  if (scrollAnimation.classList.contains("hero-section")) {
    heroEntry(showMarkers, scrollAnimation);
  }  

  if (scrollAnimation.classList.contains("info-items-section")) {
    infoItems(showMarkers, scrollAnimation);
  }   

  if (scrollAnimation.classList.contains("services-section")) {
    serviceItems(showMarkers, scrollAnimation);
  }  
  
  if (scrollAnimation.classList.contains("timeline-section")) {
    timeline(showMarkers, scrollAnimation);
  } 

  if (scrollAnimation.classList.contains("benefit-items")) {
    benefitItems(showMarkers, scrollAnimation);
  }  

  if (scrollAnimation.classList.contains("project-img-gallery")) {
    projectImgGallery(showMarkers, scrollAnimation);
  }    

  if (scrollAnimation.classList.contains("animated-abstract-section")) {
    abstractBg(showMarkers, scrollAnimation);
  }  

  if (scrollAnimation.classList.contains("office-cta-section")) {
    virtualOfficeCta(showMarkers, scrollAnimation);
  }

  if (scrollAnimation.classList.contains("blog-content-section")) {
    stickySocial(showMarkers);
  }  

});

ScrollTrigger.refresh();

// | ------------------------------------------------------------------------

// Update ScrollTrigger when page is resized
/*
window.addEventListener(
  "resize",
  function () {
    ScrollTrigger.refresh();
  },
  true
);
*/

// | ------------------------------------------------------------------------
